/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Model from '@ember-data/model';
import { attr, belongsTo, hasMany } from '@ember-data/model';
import type Category from './category';
import type Copy from './copy';
import { SettingTypes } from '../data/consent-banners/setting-types';

export default class Setting extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare bannerType: string;
  @attr('string') declare consentBannerId: string;
  @attr('boolean') declare shouldFreeze: boolean;

  @belongsTo('consent-banners/category', { async: false })
  declare category?: Category;

  @hasMany('consent-banners/copy', { async: false })
  declare copies?: Copy[];

  get isGdpr(): boolean {
    return this.bannerType === SettingTypes.GDPR;
  }

  get isSimple(): boolean {
    return this.bannerType === SettingTypes.Simple;
  }

  get isCcpa(): boolean {
    return this.bannerType === SettingTypes.CCPA;
  }

  rollbackAttributes() {
    super.rollbackAttributes();
    this.copies?.forEach((copy) => copy.rollbackAttributes());
    this.category?.rollbackAttributes();
  }
}
